import LayoutBottom from "../Components/Layout/LayoutBottom";
import LayoutTop from "../Components/Layout/LayoutTop";
import BottomParProgressbarComponent from "../Components/homepageComponents/BottomParProgressbarComponent";
import ServicesComponent from "../Components/homepageComponents/ServicesComponent";
import UserInfoComponent from "../Components/homepageComponents/UserInfoComponent";
import DesktopSliderComponent from "../Components/Sliders/DesktopSliderComponent";
import MobileSliderComponent from "../Components/Sliders/MobileSliderComponent";
import CalencarComponent from "../Components/homepageComponents/calendar/CalencarComponent";
import BodyClassName from 'react-body-classname';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

import LoginPage from "./LoginPage";
import { useAppContext } from "../AppContext";
import { getInternalPortalAnnouncements, getInternalPortalAnnouncementsASC, getInternalPortalHomeSides } from "../api/api";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";



function HomePage() {
    const app = useAppContext();
    const { t, i18n } = useTranslation();

  const user = app.user || { displayName: '', jobTitle: '' };

  const { isLoading, error, data, isFetching, refetch }: any = useQuery(
    "HomeSliderData",
    () => getInternalPortalHomeSides({ limit: 5, language: i18n.language })
  );


const { isLoading:isLoadingTarget, error:errorTarget, data:dataTarget, isFetching:isFetchingTarget, refetch:refetchTarget }: any = useQuery(
    "ServiceTargetsData",
    () => getInternalPortalAnnouncementsASC({ limit: 2,table:'service-targets', language: i18n.language })
  );
  


  useEffect(() => {
    refetch();
    refetchTarget();
  }, [i18n.language]);

  if (isLoading) return <div></div>;

  if (error) return <div></div>;

  if (isLoadingTarget) return <div></div>;
  
  if (errorTarget) return <div></div>;


  
  return (
      <>
          <AuthenticatedTemplate>
              <BodyClassName className="pb-md-5 mb-md-5">
                  <>
                      <LayoutTop />
                      <div className="wrapper06">
                          <div className="container-fluid">
                              <div className="wrapp06-item">
                                  {/* <!-- row start --> */}
                                  <div className="d-lg-flex d-block">

                                      <UserInfoComponent userData={user} />
                                      {/* <!-- single item start --> */}
                                      <div className="item-col-lg-95">
                                          <div className="row g-0 justify-content-between">

                                              <DesktopSliderComponent slides={data.data} />
                                              <MobileSliderComponent  slides={data.data} />

                                              <div className="col-sm-6 d-lg-none d-block align-self-center">
                                                  <div className="top-h4 ">
                                                      <h4 className="shape-round">خدمات تهمك </h4>
                                                  </div>
                                              </div>
                                              <div className="col-lg-3 col-sm-5 mt-sm-0 mt-4 align-self-center">
                                                  <div className="item01">
                                                      <CalencarComponent />
                                                  </div>

                                              </div>

                                          </div>

                                          <ServicesComponent />


                                      </div>
                                      {/* <!-- single item end --> */}

                                  </div>
                                  {/* <!-- row end --> */}
                                  <div className="progress-bar-body" id="progress-bar">
                                      <div className="row">
                                          {/* <!-- single item start --> */}
                                          <div className="col-xl-2 col-lg-3">
                                              <div className="item-right-prog">
                                                  <h4><div className="imgleft"> <img src="/static/img/line-bar.png" alt="img" className="img-fluid" /><img src="/static/img/rounded.png" alt="img" className="img-fluid" /></div>طلبات التسجيل <br className="d-lg-block d-none" />
                                                      في خدمة النقل </h4>
                                              </div>
                                          </div>
                                          <div className="col-xl-9 col-lg-9 mt-lg-0 mt-4">
                                              <BottomParProgressbarComponent service={dataTarget.data[0]}/>
                                          </div>
                                          {/* <!-- single item end --> */}

                                      </div>
                                      <div className="row mt-lg-0 mt-sm-3 mt-4">
                                          {/* <!-- single item start --> */}
                                          <div className="col-xl-2 col-lg-3 d-lg-block d-none">
 
                                          </div>
                                          <div className="col-xl-9 col-lg-9">
                                          <BottomParProgressbarComponent service={dataTarget.data[1]}/>

                                          </div>
                                          {/* <!-- single item end --> */}

                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <LayoutBottom />
                  </>
              </BodyClassName>
          </AuthenticatedTemplate>

          <UnauthenticatedTemplate>
              <LoginPage />
          </UnauthenticatedTemplate>
      </>
  );
}

export default HomePage;
